import { render, staticRenderFns } from "./Skype.vue?vue&type=template&id=7c0ab445&"
import script from "./Skype.vue?vue&type=script&lang=js&"
export * from "./Skype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0ab445')) {
      api.createRecord('7c0ab445', component.options)
    } else {
      api.reload('7c0ab445', component.options)
    }
    module.hot.accept("./Skype.vue?vue&type=template&id=7c0ab445&", function () {
      api.rerender('7c0ab445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/control/Skype.vue"
export default component.exports